import { render, staticRenderFns } from "./PercentArrowInput.vue?vue&type=template&id=588b16c6&"
import script from "./PercentArrowInput.vue?vue&type=script&lang=js&"
export * from "./PercentArrowInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports